import { apiEndPoint } from "./endPoint";

interface subscriptionData {
  endpoint: string;
  expirationTime?: any;
  keys: {
    auth: string;
    p256dh: string;
  };
}

interface NotificationDataForSave {
  userId: string;
  time: string;
  subscription: subscriptionData;
}

export const createEvent = async (
  NotificationData: NotificationDataForSave,
  token: string
) => {
  const url = `${apiEndPoint}/createEvent`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(NotificationData),
    });

    if (response.ok) {
      const responseData = await response.json();
      console.log(response);
      return { ...responseData, status: 200 };
    } else {
      throw new Error("Failed to fetch");
    }
  } catch (err) {
    console.error("Error:", err);
    return {
      role: "error",
      content: "エラーが発生したようです。初めからやり直してください。",
    };
  }
};
